/**
 * Custom panel placeholder component.
 * This file is overridden by jitsi-meet-branding at build time
 * to provide the actual panel implementation with iframe content.
 *
 * @returns {null} This placeholder renders nothing.
 */
const CustomPanel = () => null;
export default CustomPanel;
